import { render, staticRenderFns } from "./CubeNavComponent.vue?vue&type=template&id=d6f94510&scoped=true&"
import script from "./CubeNavComponent.vue?vue&type=script&lang=js&"
export * from "./CubeNavComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f94510",
  null
  
)

export default component.exports